export type {
  YardAssetDetails,
  AssetContainerStatePresentationInput
} from './yardAssetPresenterV2Shared';

export {
  getAssetContainerStatusIcon,
  getAssetContainerStatusColor,
  getAssetContainerStateIcon
} from './yardAssetPresenterV2Shared';

export { useYardAssetFetcherV2 } from './useYardAssetFetcherV2';
export type { UseYardAssetFetcherV2Options } from './useYardAssetFetcherV2';
export type { UseYardAssetFetcherV2Options as UseYardAssetPresenterV2Options } from './useYardAssetFetcherV2';

export { useYardAssetDisplayV2 } from './useYardAssetDisplayV2';
export type {
  YardAssetDisplayField,
  YardAssetDisplayV2Data,
  YardAssetDisplayV2State,
  UseYardAssetDisplayV2Options
} from './useYardAssetDisplayV2';

import { useYardAssetFetcherV2 } from './useYardAssetFetcherV2';

import type { UseYardAssetFetcherV2Options } from './useYardAssetFetcherV2';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardAssetFetcherV2}.
 * Pair with {@link useYardAssetDisplayV2} when fetch is owned by a parent (e.g. list row).
 */
export function useYardAssetPresenterV2(options: UseYardAssetFetcherV2Options) {
  return useYardAssetFetcherV2(options);
}
